<template lang="pug">

  text-input(name="city", :label="label", meta)

</template>

<script>

import TextInput from './TextInput'

export default {
  name: 'user-input-city',

  components: {
    TextInput,
  },

  props: {
    label: {
      type: String,
      default: 'City',
    },
  },
}

</script>
